
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46locationSlug_93PygVLI20KKMeta } from "/vercel/path0/pages/[...locationSlug].vue?macro=true";
import { default as _404lZJpwxvtooMeta } from "/vercel/path0/pages/404.vue?macro=true";
import { default as indexqOnLrLMUjLMeta } from "/vercel/path0/pages/account/index.vue?macro=true";
import { default as indexkppHktB81xMeta } from "/vercel/path0/pages/auth/index.vue?macro=true";
import { default as index1lVmB4IgMRMeta } from "/vercel/path0/pages/contact-us/index.vue?macro=true";
import { default as index2gdyFwvmrjMeta } from "/vercel/path0/pages/flight/[uid]/index.vue?macro=true";
import { default as indexuH26iZVe6PMeta } from "/vercel/path0/pages/flights/v1/[uid]/index.vue?macro=true";
import { default as indexl2okl8Qro2Meta } from "/vercel/path0/pages/gmail-link/failure/index.vue?macro=true";
import { default as indexK6FIkkXiJkMeta } from "/vercel/path0/pages/gmail-link/index.vue?macro=true";
import { default as indexWG9mCmLQInMeta } from "/vercel/path0/pages/gmail-link/success/index.vue?macro=true";
import { default as indexa0BDxELIOsMeta } from "/vercel/path0/pages/go/[uid]/index.vue?macro=true";
import { default as indexgqoUxXFqBAMeta } from "/vercel/path0/pages/go/index.vue?macro=true";
import { default as indexfMHZkUaQDzMeta } from "/vercel/path0/pages/go/success/index.vue?macro=true";
import { default as indexfgiwrlFjmpMeta } from "/vercel/path0/pages/index/index.vue?macro=true";
import { default as indexcHkyKl579RMeta } from "/vercel/path0/pages/json-internal/index.vue?macro=true";
import { default as indexnR1YAnMRZbMeta } from "/vercel/path0/pages/pick/[uid]/index.vue?macro=true";
import { default as indexYPAS6e4VgdMeta } from "/vercel/path0/pages/picksV2/[uid]/index.vue?macro=true";
import { default as indexa7SLYrUpNFMeta } from "/vercel/path0/pages/privacy/index.vue?macro=true";
import { default as indexIhrhCp8oIFMeta } from "/vercel/path0/pages/subscribe/index.vue?macro=true";
import { default as index9OiDgfx7OcMeta } from "/vercel/path0/pages/terms/index.vue?macro=true";
import { default as indexC5RT3a1hgnMeta } from "/vercel/path0/pages/trynow/index.vue?macro=true";
import { default as component_45stub5X4Ei38PMgMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5X4Ei38PMg } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "locationSlug",
    path: "/:locationSlug(.*)*",
    component: () => import("/vercel/path0/pages/[...locationSlug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/vercel/path0/pages/404.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexqOnLrLMUjLMeta || {},
    component: () => import("/vercel/path0/pages/account/index.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexkppHktB81xMeta || {},
    component: () => import("/vercel/path0/pages/auth/index.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/vercel/path0/pages/contact-us/index.vue")
  },
  {
    name: "flight-uid",
    path: "/flight/:uid()",
    component: () => import("/vercel/path0/pages/flight/[uid]/index.vue")
  },
  {
    name: "flights-v1-uid",
    path: "/flights/v1/:uid()",
    component: () => import("/vercel/path0/pages/flights/v1/[uid]/index.vue")
  },
  {
    name: "gmail-link-failure",
    path: "/gmail-link/failure",
    component: () => import("/vercel/path0/pages/gmail-link/failure/index.vue")
  },
  {
    name: "gmail-link",
    path: "/gmail-link",
    component: () => import("/vercel/path0/pages/gmail-link/index.vue")
  },
  {
    name: "gmail-link-success",
    path: "/gmail-link/success",
    component: () => import("/vercel/path0/pages/gmail-link/success/index.vue")
  },
  {
    name: "go-uid",
    path: "/go/:uid()",
    component: () => import("/vercel/path0/pages/go/[uid]/index.vue")
  },
  {
    name: "go",
    path: "/go",
    component: () => import("/vercel/path0/pages/go/index.vue")
  },
  {
    name: "go-success",
    path: "/go/success",
    component: () => import("/vercel/path0/pages/go/success/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index/index.vue")
  },
  {
    name: "json-internal",
    path: "/json-internal",
    component: () => import("/vercel/path0/pages/json-internal/index.vue")
  },
  {
    name: "pick-uid",
    path: "/pick/:uid()",
    component: () => import("/vercel/path0/pages/pick/[uid]/index.vue")
  },
  {
    name: "picksV2-uid",
    path: "/picksV2/:uid()",
    component: () => import("/vercel/path0/pages/picksV2/[uid]/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/vercel/path0/pages/privacy/index.vue")
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: () => import("/vercel/path0/pages/subscribe/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/vercel/path0/pages/terms/index.vue")
  },
  {
    name: "trynow",
    path: "/trynow",
    component: () => import("/vercel/path0/pages/trynow/index.vue")
  },
  {
    name: component_45stub5X4Ei38PMgMeta?.name,
    path: "/bizV2",
    component: component_45stub5X4Ei38PMg
  }
]